import { Component, inject } from "@angular/core"
import { NavItemComponent } from "./navigationItem.component"
import { AppRoute } from "@app-types/appRoute"
import { AuthenticationService } from "@app/services/authentication/authentication.service"
import { Option } from "@app/types/option"

@Component({
    selector: 'vco-purchasing-co-op-navigation',
    imports: [NavItemComponent],
    template: `
        @if (Option.orUndefined(user()); as user) {
            @if (user.role === 'GlobalAdmin') {
                <details open>
                    <summary>Contracts</summary>
                    <ul>
                        <vco-nav-item label="Contract List" [routerLink]="route.contractList"></vco-nav-item>
                        <vco-nav-item label="Create a New Contract" [routerLink]="route.newContract"></vco-nav-item>
                    </ul>
                </details>                
            }

            <details open>
                <summary>Orders</summary>
                <ul>
                    <vco-nav-item label="Order List" [routerLink]="route.orderList"></vco-nav-item>
                    @if (user.role === 'Member' && user.summary.canInitiatePurchases) {
                        <vco-nav-item label="Create a New Order" [routerLink]="route.newOrder"></vco-nav-item>
                    }
                </ul>
            </details>

            @if (user.role === 'GlobalAdmin') {
                <details open>
                    <summary>Vehicles</summary>
                    <ul>
                        <vco-nav-item label="Vehicle Type List" [routerLink]="route.vehicleTypeList"></vco-nav-item>
                        <vco-nav-item label="Vehicle Class List" [routerLink]="route.vehicleClassList"></vco-nav-item>
                    </ul>
                </details>
            }

            @if (user.role === 'GlobalAdmin' || user.role === 'Seller' || user.role === 'Member') {
                <details open>
                    <summary>Reports</summary>
                    <ul>
                        @if (user.role === 'GlobalAdmin') {
                            <vco-nav-item label="Vehicle Report" [routerLink]="route.vehicleReport"></vco-nav-item>
                            <vco-nav-item label="Pending Payments" [routerLink]="route.pendingPayments"></vco-nav-item>
                        }
                        @if (user.role === 'Seller') {
                            <vco-nav-item label="Dealer Invoice" [routerLink]="route.sellerVehicles"></vco-nav-item>
                        }
                        @if (user.role === 'Member') {
                            <vco-nav-item label="Options Activity Report" [routerLink]="route.vehicleLimitAdjustments"></vco-nav-item>
                        }
                    </ul>
                </details>
            }
        }
    `,
}) export class PurchasingCoOpNavigationComponent {
    private readonly _authenticationService = inject(AuthenticationService)

    readonly user = this._authenticationService.authenticatedUser

    readonly route = {
        contractList: AppRoute.create(['purchasingCoOp', 'contracts', 'contractList']),
        newContract: AppRoute.create(['purchasingCoOp', 'contracts', 'newContract']),
        vehicleTypeList: AppRoute.create(['purchasingCoOp', 'vehicles', 'vehicleTypeList']),
        vehicleClassList: AppRoute.create(['purchasingCoOp', 'vehicles', 'vehicleClassList']),
        orderList: AppRoute.create(['purchasingCoOp', 'orders', 'orderList']),
        newOrder: AppRoute.create(['purchasingCoOp', 'orders', 'order']),
        vehicleReport: AppRoute.create(['purchasingCoOp', 'reports', 'vehicleReport']),
        pendingPayments: AppRoute.create(['purchasingCoOp', 'reports', 'pendingPayments']),
        sellerVehicles: AppRoute.create(['purchasingCoOp', 'reports', 'sellerVehicles']),
        vehicleLimitAdjustments: AppRoute.create(['purchasingCoOp', 'reports', 'vehicleLimitAdjustments']),
    }

    readonly Option = Option
}